define('plugin/line-liff/view/LineLiffClientLoginStepView',['require','lib/view/FormView','Config','lib/Utils','lib/WindowMessageListener','lib/view/mixin/IntlPhone'],function (require) {

    var FormView = require('lib/view/FormView');
    var Config = require('Config');
    var Utils = require('lib/Utils');
    //var ClientProfileFormBehavior = require('plugin/client-login/view/ClientProfileFormBehavior');
    var WindowMessageListener = require('lib/WindowMessageListener');

    var IntlPhone = require('lib/view/mixin/IntlPhone');
    /**
     * Client login view
     *
     * @class ClientLoginStepView
     */
    return FormView.extend({

        template: '#line_liff_client_login_step',
        ui: {
            'sign_in_data': '#sb_sign_in_form :input',
            // 'sign_up_data': '#sb_sign_up_form :input',
            // 'sign_in_btn': '#sb_sign_in_btn',
            // 'sign_up_btn': '#sb_sign_up_btn',
            // 'phoneInput' : ':input[name=phone]',
            'builtInFields': '.sb-built-in-fields',
            'login_via_line' : '#login-line-liff',
            'skip_step' : '#skip-line-liff',
        },
        triggers: {
             'click @ui.login_via_line': 'signIn',
             'click @ui.skip_step': 'skipStep'
        },
        events: {
            // 'keyup @ui.sign_in_data': '_onSignInInputKeyUp',
            // 'keyup @ui.sign_up_data': '_onSignUpInputKeyUp'
        },
        message: null,
        //currentTab: 'sign_in',
        regions: {
            'terms': {
                'el': '#sb_terms_and_conditions',
                'allowMissingEl': true
            }
        },

        // behaviors: function () {
        //     return {
        //         ClientProfileFormBehavior: {
        //             behaviorClass: ClientProfileFormBehavior,
        //             model: this.getOption('clientModel')
        //         }
        //     };
        // },

        initialize: function () {
            this.listenTo(this.getOption('clientModel'), 'sync', this.checkIfClientLoggedIn);

            ///this.listenTo(this.getOption('clientModel'), 'invalid', this.renderSignUp);
           // this.listenTo(this.getOption('signInModel'), 'invalid', this.renderSignIn);
            this.listenTo(this.getOption('termsModel'), 'invalid', this.render);

            this.listenTo(this.getOption('clientModel'), 'change', this.render);

            this.message = this.getOption('message');
            this.onlySignIn = this.getOption('onlySignIn');

            //this.initOpenIdAuth();

        },

        /**
         * On render add custom views to regions
         */
        onRender: function () {
            // var config = Config.getInstance();
            // IntlPhone.showIntlPhone(this.ui.phoneInput, {
            //     //required : false,
            //     numberDisplayFormat: 'NATIONAL',
            //     countryPrefix: config.getOption('country_prefix'),
            //     countryPrefixId: config.getOption('country_prefix_id'),
            //     allowedPrefix: config.getOption('country_prefix_is_changeable')?null:config.getOption('country_prefix'),
            // });
            
            Backbone.Wreqr.radio.vent.trigger('page', 'render', {
                'page': 'line_liff',
                'view': this,
                'client_model': this.getOption('clientModel')
            });
        },
        // /**
        //  * Listen to messages from open id login window and fetch/update client data
        //  */
        // initOpenIdAuth: function () {
        //     var listener = new WindowMessageListener();
        //     this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        // },
        //
        // /**
        //  * Handle open id login message
        //  *
        //  * @private
        //  */
        // _handleWindowMessage: function (data) {
        //     if (data.open_id_message && !data.client) {
        //         this.message = 'open_id';
        //         if (!this.isDestroyed) {
        //             this.render();
        //         }
        //     }
        // },

        showTermsAndConditions: function (view) {
            this.terms.show(view);
        },

        // renderSignUp: function () {
        //     this.currentTab = 'sign_up';
        //     this.render();
        // },
        //
        // renderSignIn: function () {
        //     this.message = null;
        //     this.currentTab = 'sign_in';
        //     this.render();
        // },
        //
        checkIfClientLoggedIn: function () {
            if (this.getOption('clientModel').get('is_logged_in')) {
                this.triggerMethod('clientLogged');
            } else {
                this.triggerMethod('clientLoggedOut');
            }
        },

        getDataToSignIn: function () {
            return this._getData(this.ui.sign_in_data);
        },

        serializeData: function () {
            var result = FormView.prototype.serializeData.apply(this);

            return _.extend({
                'info_message': this.message,
                'only_sign_in': this.onlySignIn,
            }, result);
        },

        onDomRefresh: function () {
            if (this.message) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown', {
                    'type': 'line_liff_message'
                });
            } else {
                Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                    'page': 'line_liff'
                });
            }
        },
        
/*        _onSignInInputKeyUp: function (event) {
            if (event.keyCode === this.KEY_ENTER && !event.shiftKey) {
                this.ui.sign_in_btn.trigger('click');
            }
        },
        
        _onSignUpInputKeyUp: function (event) {
            if (event.keyCode === this.KEY_ENTER && !event.shiftKey) {
                this.ui.sign_up_btn.trigger('click');
            }
        },
        */

        hideBuiltInFields: function () {
            this.ui.builtInFields.hide();
        }

    });

});
